import TooltipIcon from '../../../ui/tooltip';
import { useCreditForm } from 'src/customHooks/useCreditForm';
import { useLocalization } from 'src/utils/useLocalization';
import React, { Dispatch, SetStateAction } from 'react';

import './style.scss';

interface INotesProps {
    content: string;
    setContent: Dispatch<SetStateAction<string>>;
}

const Notes: React.FC<INotesProps> = ({ content, setContent }) => {
    const { creditAppOtherInformation } = useLocalization();
    const { markCreditFormTouched } = useCreditForm();

    return (
        <>
            <div className='o-fieldset__row'>
                <div className='o-layout'>
                    <div className='o-layout__item u-1/1'>
                        {creditAppOtherInformation.NOTES_INFO}
                    </div>
                </div>
            </div>
            <div className='o-fieldset__row'>
                <div className='c-form-field'>
                    <div>
                        <label
                            htmlFor='m1l7e063'
                            className='c-form-field__label'
                        >
                            {creditAppOtherInformation.NOTES_LABEL} &nbsp;
                        </label>
                        <TooltipIcon
                            text={creditAppOtherInformation.NOTES_TOOLTIP}
                        ></TooltipIcon>
                    </div>
                </div>
                <div className='c-input c-input--textarea'>
                    <textarea
                        className='c-input__input'
                        id='notes'
                        rows={10}
                        value={content}
                        onChange={(e) => {
                            setContent(e.target.value);
                            markCreditFormTouched();
                        }}
                    ></textarea>
                </div>
            </div>
        </>
    );
};

export default Notes;
